
import { handleError } from "@/lib/utility/handleError";
import { ITemplate } from "@/models/template.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import TemplateDetail from "./TemplateDetail.vue";

@Component({
  components: { SideCard, TemplateDetail, LatestEntriesCardEmpty }
})
export default class TemplateSideCard extends mixins(Vue) {
  @Prop()
  value!: ITemplate;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  isLoading = false;

  async mounted() {
    try {
      this.isLoading = true;

      await this.value.fetch();
    } catch (error) {
      handleError(error);
      this.close();
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
